import React from 'react'
import ProductGallery from './components/ProductGallery'

export default function Home(){
  return (
    <main>
      {/* Hero Carousel Section */}
      <section className="hero-section">
        <div className="container-fluid p-0">
          <div id="header-carousel" className="carousel slide carousel-fade" data-ride="carousel">
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img className="carousel-image" src="/img/Sliderimg1.jpg" alt="Pharmaceutical manufacturing facility" loading="lazy" />
              </div>
              <div className="carousel-item">
                <img className="carousel-image" src="/img/Sliderimg2.jpg" alt="Quality pharmaceutical products" loading="lazy" />
              </div>
              <div className="carousel-item">
                <img className="carousel-image carousel-image-offset" src="/img/about_header2.jpg" alt="Lakulish Pharmaceuticals research" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Welcome Section */}
      <section className="welcome-section py-5 mb-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 text-center mb-5">
              <h1 className="display-4 font-weight-bold text-primary mb-4">Welcome to Lakulish Pharmaceuticals</h1>
              <p className="lead text-muted">Leading pharmaceutical innovation for better health worldwide</p>
            </div>
          </div>
          <div className="row align-items-center">
            {/* <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body d-flex align-items-center justify-content-center text-center">
                  <div>
                    <h3 className="text-primary mb-3">🏥</h3>
                    <h4 className="card-title text-primary">Quality Healthcare Solutions</h4>
                    <p className="card-text text-muted">Dedicated to providing superior pharmaceutical products and services worldwide</p>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="col-lg">
              <div className="card border-0 shadow-sm">
                <div className="card-body">
                  <h2 className="card-title section-title mb-4">Seeking for a Better Health</h2>
                  <p className="card-text text-muted mb-4">"LAKULISH PHARMACEUTICALS" specializes in Formulation Development, Contract Research and Contract Manufacturing, In/out-licensing, Marketing and distribution of <b>Finished Pharmaceutical Formulation, Biological, Nutraceutical, Ayurvedic, Medical Device & Cosmetic Products</b> in USA, Latin America, Europe, Canada, Australia, South Africa and other African countries, Middle East Countries, CIS, Asian countries, ROW & Domestic market.</p>
                  <p className="card-text text-muted mb-4">As a leading player in the Indian pharmaceutical industry, we aim to establish our presence worldwide and ensure that our credibility remains intact all times. Integrity, respect, collaboration, excellence, leadership and innovation are the core values that embody how LAKULISH operates.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </main>
  )
}
